module.exports = __webpack_public_path__ + "assets/img/activity_annual_vip_bg.a4327f1b.png";